export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            关于吃瓜网站线路一
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <p className="text-foreground-700 leading-relaxed mb-4">
              吃瓜网站线路一作为<strong>51吃瓜官网全网最新入口</strong>，自上线以来始终坚持「快、全、准」的内容理念，为您提供一站式的吃瓜体验。我们聚合全网优质吃瓜内容，覆盖<strong>娱乐圈、网红圈、商业圈、体育圈</strong>等各大领域，每日更新海量新鲜爆料和深度解读。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              无论是<strong>51吃瓜网址</strong>的便捷入口，还是<strong>吃瓜网站首页</strong>的精选推荐，我们都力求让每一位访问者都能在最短时间内获取最有价值的信息。同时，我们始终坚持<strong>隐私保护</strong>原则，确保您在浏览51吃瓜网的过程中全程匿名、安全无忧。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              感谢您选择<strong>吃瓜网站线路一</strong>，我们将持续优化内容和服务，为您带来更好的吃瓜体验。收藏我们的<strong>51吃瓜线路一入口</strong>，随时随地畅享全网最新吃瓜内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}